import { createSlice } from '@reduxjs/toolkit';

interface UIState {
    isSidebarOpen: boolean;
    isSidebarOpenOnMobile: boolean;
}

const initialState: UIState = {
    isSidebarOpen: localStorage.getItem('sidebarState') === 'open',
    isSidebarOpenOnMobile: localStorage.getItem('sidebarOnMobileState') === 'open',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen;
            localStorage.setItem('sidebarState', state.isSidebarOpen ? 'open' : 'closed');
        },
        toggleSidebarOnMobile: (state) => {
            state.isSidebarOpenOnMobile = !state.isSidebarOpenOnMobile;
            localStorage.setItem('sidebarOnMobileState', state.isSidebarOpenOnMobile ? 'open' : 'closed');
        },
    },
});

export const { toggleSidebar, toggleSidebarOnMobile } = uiSlice.actions;
export default uiSlice.reducer;
